import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-white",
  "use": "icon-arrow-right-white-usage",
  "viewBox": "0 0 10 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 18\" id=\"icon-arrow-right-white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.272 1.774 1.686.36l8.029 8.028a.875.875 0 0 1 0 1.238l-8.029 8.028L.272 16.24l7.233-7.233L.272 1.774Z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol